import { createContext } from 'react';

const PlanContext = createContext({});

export default PlanContext;
